import { Tag } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { scheduleConstraintLabels } from 'features/schedule-configuration/model';
import type { ScheduleConstraintCategory, ScheduleConstraintCode } from 'services/api';
import styles from '../ui/components/StatusTag/ui/styles.module.scss';

export const getContsraintTag = (
  code?: ScheduleConstraintCode,
  category?: ScheduleConstraintCategory,
) => {
  if (!code || !category) {
    return null;
  }
  switch (category) {
    case 'LOGICAL':
      return (
        <Tag
          icon={<ExclamationCircleOutlined />}
          color="magenta"
          className={classNames(styles.tag, styles.tag_logical)}
        >
          Логический конфликт: {scheduleConstraintLabels[code]}
        </Tag>
      );
    case 'SANPIN':
      return (
        <Tag
          icon={<ExclamationCircleOutlined />}
          color="gold"
          className={classNames(styles.tag, styles.tag_sanpin)}
        >
          Конфликт СанПиН:
          {scheduleConstraintLabels[code]}
        </Tag>
      );
    default:
      return code;
  }
};
